import React from 'react';
import {Link, useLocation} from 'react-router-dom';
import './Person.sass';
import Picture from '../../../components/Picture';
import {constructDevSrc} from '../../../utils/helpers';
import {ReactComponent as LinkedinLogo} from '../../Icons/linkedin-logo.svg';
import {ReactComponent as FacebookLogo} from '../../Icons/facebook-logo.svg';
import {ReactComponent as TwitterLogo} from '../../Icons/twitter-logo.svg';
import {Speakers} from '../../../types';

type Props = {
  data: NonNullable<NonNullable<Speakers>[0]>;
};

function Person({data}: Props) {
  const {
    speakerName,
    location,
    speakerPreviewDescription,
    speakerImage,
    _url: url,
    facebookLink: fb,
    twitterLink: tw,
    linkedinLink: ld,
  } = data;

  const LOCATION = useLocation()
  const {pathname} = LOCATION;

  const facebookLink = buildSocialUrl(fb || '');
  const twitterLink = buildSocialUrl(tw || '');
  const linkedinLink = buildSocialUrl(ld || '');

  return (
    <article className="uikit-card-person">
      {pathname === url
        ? null
        : <Link
          to={url || ''}
          className="uikit-card-person__link"
          title="Speaker"
        />
      }
      <Picture
        className="uikit-card-person__photo"
        // @ts-ignore
        imageObj={speakerImage}
      />
      <h3 className="uikit-text-regular uikit-card-person__name">
        {speakerName}
      </h3>
      <p className="uikit-text-small uikit-card-person__job">
        {speakerPreviewDescription}
      </p>
      <div className="uikit-card-person__bottom">
        <div className="uikit-card-person__socials">
          {linkedinLink && (
            <a href={linkedinLink} target="_blank" rel="noreferrer">
              <LinkedinLogo/>
            </a>
          )}
          {facebookLink && (
            <a href={facebookLink} target="_blank" rel="noreferrer">
              <FacebookLogo/>
            </a>
          )}
          {twitterLink && (
            <a href={twitterLink} target="_blank" rel="noreferrer">
              <TwitterLogo/>
            </a>
          )}
        </div>
        <div className="uikit-card-person__flag">
          {location?.country?._url && (
            <img
              src={constructDevSrc(location?.country?._url)}
              alt={location?.countryName}
            />
          )}
        </div>
      </div>
    </article>
  );
}

export default Person;

function buildSocialUrl(url: string | undefined): string | undefined {
  const httpStr = 'https://';
  if (url) {
    return !url.includes('https://') ? `${httpStr}${url}` : url;
  }

  return undefined;
}
